// This file is auto-generated by rush-gen

import { createClient, createConfig } from '@hey-api/client-fetch';

export const client = createClient(createConfig());
